import React from 'react'
import {backgroundDark,backgroundLight} from "../assets/images"
import { useStateContext } from '../context/ContextProvider'
import {  Footer, Header } from '../components/layout'
import { productsData } from '../constants'
import { Product_card } from '../components/products'
const Products = () => {
  const {currentMode}=useStateContext()
  const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
  return (
    <div className='w-full'
    style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <Header activeLink={"/Products"} />
      <div className="container pt-24 pd:mt-32 lg:pt-36 ">

        <div className="w-ful grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {
                productsData.map((card)=>(
                    <Product_card card={card} />
                ))
            }
        </div>
      </div>

      <Footer />
      </div>
  )
}

export default Products